import { useChildComponentRouteV2 } from '@gogame/screens';

import SpendAdjustmentDetails from './SpendAdjustmentDetails';

export const SpendAdjustmentDetailsRouteElement = () => {
  return useChildComponentRouteV2(SpendAdjustmentDetails);
};
